import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useCurrency } from '@shared/selectors/globalSelectors';
import { useSearchParams } from 'react-router-dom';

export const OrderSummary = ({ allStepData }: { allStepData?: any }) => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'bills';

  const selectedBillIds = allStepData?.[0]?.selectedBills || [];
  const currency=useCurrency()
  // Get the selected bills data directly from the step data
  const selectedBillsData = allStepData?.[0]?.selectedBillsData || [];
  
  // Calculate total amount
  const totalAmount = selectedBillsData.reduce((sum: any, bill: any) => sum + bill.amount, 0);

  const consumerDetails = localStorage.getItem("loginResult");
  const parsed = consumerDetails ? JSON.parse(consumerDetails) : null;
  const consumerName = parsed?.result ? `${parsed.result.firstName} ${parsed.result.lastName}`.trim() : 'Consumer';
  const consumerNo = parsed?.result?.consumerNo || '';

  return (
    <div className="bg-white rounded-xl border p-6">
      <h3 className="font-semibold text-lg mb-4 text-gray-900">Order Summary</h3>
      
      <div className="mb-6">
        <p className="text-sm text-gray-600 flex items-center gap-2">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
          {consumerName}
        </p>
        <p className="text-xs text-gray-400 mt-1 pl-6">{consumerNo}</p>
      </div>
      
      {selectedBillsData.length > 0 ? (
        <div className="space-y-3 mb-6">
          {selectedBillsData.map(bill => (
            <div key={bill.id} className="flex justify-between text-sm">
              <span className="text-gray-600">{bill.month}</span>
              <span className="font-medium text-gray-900">{currency} {bill.amount.toFixed(2)}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-sm text-gray-500 mb-6 italic">No {type === 'services' ? 'services' : type === 'installment' ? 'installment' : 'bills'} selected</div>
      )}
      
      <div className="pt-4 border-t flex justify-between items-center">
        <span className="font-bold text-gray-900">Total</span>
        <span className="font-bold text-blue-700 text-lg">${totalAmount.toFixed(2)}</span>
      </div>
    </div>
  );
};

export const SafeAndSecure = () => {
  return (
    <div className="bg-white rounded-xl border p-6 mt-4">
      <div className="flex items-center gap-2 mb-4">
        <ShieldCheck className="w-5 h-5 text-green-600" />
        <h3 className="font-semibold text-gray-900">Safe & Secure</h3>
      </div>
      
      <ul className="space-y-3 text-sm text-gray-600">
        <li className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full border border-green-500 flex items-center justify-center text-green-600 shrink-0">
            <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          SSL Encrypted
        </li>
        <li className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full border border-green-500 flex items-center justify-center text-green-600 shrink-0">
            <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          PCI DSS Compliant
        </li>
        <li className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full border border-green-500 flex items-center justify-center text-green-600 shrink-0">
            <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          Instant Receipt
        </li>
        <li className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full border border-green-500 flex items-center justify-center text-green-600 shrink-0">
            <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
          </div>
          Refund in 5-7 days
        </li>
      </ul>
    </div>
  );
};
